import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import ChatAgent from './ChatAgent';


/**
 * This component creates the main structure with a sidebar and a content area.
 * It manages the collapsed state of the sidebar, which will persist
 * across all pages that use this layout.
 */
function Layout({ children }) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed(prevState => !prevState);
  };

  return (
    <div className="layout-container">
      <Sidebar isCollapsed={isCollapsed} toggleCollapse={toggleCollapse} />
      <main className="main-content">
        <Outlet />
      </main>
      <ChatAgent />
    </div>
  );
}

export default Layout;